module.exports = __webpack_public_path__ + "static/media/banner-maxi-frete.0765e248.png";